import _objectSpread from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _slicedToArray from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// cannot be dynamically imported
import { Buffer } from 'buffer';
var TREZOR_DEFAULT_PATH = "m/44'/60'/0'/0";
var assets = [{
  label: 'ETH'
}];
var DEFAULT_BASE_PATHS = [{
  label: 'Ethereum Mainnet',
  value: TREZOR_DEFAULT_PATH
}];

var getAccount = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, asset, index, provider) {
    var publicKey, chainCode, path, _yield$import, HDKey, ethUtil, _ref3, publicToAddress, toChecksumAddress, hdk, dkey, address;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            publicKey = _ref.publicKey, chainCode = _ref.chainCode, path = _ref.path;
            _context.next = 3;
            return import('hdkey');

          case 3:
            _yield$import = _context.sent;
            HDKey = _yield$import.default;
            _context.next = 7;
            return import('ethereumjs-util');

          case 7:
            ethUtil = _context.sent;
            // @ts-ignore - Commonjs importing weirdness
            _ref3 = ethUtil.default || ethUtil, publicToAddress = _ref3.publicToAddress, toChecksumAddress = _ref3.toChecksumAddress;
            hdk = new HDKey();
            hdk.publicKey = Buffer.from(publicKey, 'hex');
            hdk.chainCode = Buffer.from(chainCode, 'hex');
            dkey = hdk.deriveChild(index);
            address = toChecksumAddress("0x".concat(publicToAddress(dkey.publicKey, true).toString('hex')));
            _context.t0 = "".concat(path, "/").concat(index);
            _context.t1 = address;
            _context.t2 = asset.label;
            _context.next = 19;
            return provider.getBalance(address);

          case 19:
            _context.t3 = _context.sent;
            _context.t4 = {
              asset: _context.t2,
              value: _context.t3
            };
            return _context.abrupt("return", {
              derivationPath: _context.t0,
              address: _context.t1,
              balance: _context.t4
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAccount(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getAddresses = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(account, asset, provider) {
    var accounts, index, zeroBalanceAccounts, acc;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accounts = [];
            index = 0;
            zeroBalanceAccounts = 0; // Iterates until a 0 balance account is found
            // Then adds 4 more 0 balance accounts to the array

          case 3:
            if (!(zeroBalanceAccounts < 5)) {
              _context2.next = 11;
              break;
            }

            _context2.next = 6;
            return getAccount(account, asset, index, provider);

          case 6:
            acc = _context2.sent;

            if (acc && acc.hasOwnProperty('balance') && acc.balance.hasOwnProperty('value') && acc.balance.value.isZero()) {
              zeroBalanceAccounts++;
              accounts.push(acc);
            } else {
              accounts.push(acc); // Reset the number of 0 balance accounts

              zeroBalanceAccounts = 0;
            }

            index++;
            _context2.next = 3;
            break;

          case 11:
            return _context2.abrupt("return", accounts);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAddresses(_x5, _x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();

function trezor(options) {
  var getIcon = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return import('./icon.js');

            case 2:
              return _context3.abrupt("return", _context3.sent.default);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getIcon() {
      return _ref5.apply(this, arguments);
    };
  }();

  return function () {
    var accounts;
    return {
      label: 'Trezor',
      getIcon: getIcon,
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(_ref6) {
          var EventEmitter, chains, _yield$import2, Trezor, _yield$import3, Transaction, _yield$import4, accountSelect, bigNumberFieldsToStrings, createEIP1193Provider, ProviderRpcError, getCommon, getHardwareWalletProvider, ethUtil, compress, _yield$import5, StaticJsonRpcProvider, email, appUrl, customNetwork, TrezorConnect, eventEmitter, currentChain, account, ethersProvider, scanAccounts, getAccountFromAccountSelect, getAddress, _getAddress, getPublicKey, _getPublicKey, createTrezorTransactionObject, trezorSignTransaction, signTransaction, _signTransaction, signMessage, _signMessage, trezorProvider, provider;

          return _regeneratorRuntime().wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _signMessage = function _signMessage3() {
                    _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(address, message) {
                      var accountToSign;
                      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                        while (1) {
                          switch (_context18.prev = _context18.next) {
                            case 0:
                              if (!(!Array.isArray(accounts) || !accounts.length)) {
                                _context18.next = 2;
                                break;
                              }

                              throw new Error('No account selected. Must call eth_requestAccounts first.');

                            case 2:
                              accountToSign = accounts.find(function (account) {
                                return account.address === address;
                              }) || accounts[0];
                              return _context18.abrupt("return", new Promise(function (resolve, reject) {
                                TrezorConnect.ethereumSignMessage({
                                  path: accountToSign.derivationPath,
                                  message: ethUtil.stripHexPrefix(message.data),
                                  hex: true
                                }).then(function (response) {
                                  if (response.success) {
                                    if (response.payload.address !== ethUtil.toChecksumAddress(address)) {
                                      reject(new Error('signature doesnt match the right address'));
                                    }

                                    var signature = "0x".concat(response.payload.signature);
                                    resolve(signature);
                                  } else {
                                    reject(new Error(response.payload && response.payload.error || 'There was an error signing a message'));
                                  }
                                });
                              }));

                            case 4:
                            case "end":
                              return _context18.stop();
                          }
                        }
                      }, _callee18);
                    }));
                    return _signMessage.apply(this, arguments);
                  };

                  signMessage = function _signMessage2(_x13, _x14) {
                    return _signMessage.apply(this, arguments);
                  };

                  _signTransaction = function _signTransaction3() {
                    _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(transactionObject) {
                      var signingAccount, _signingAccount, derivationPath, address, signer, populatedTransaction, updateBigNumberFields, transactionData, chainId, common, trezorResult, message, _trezorResult$payload, r, s, v, rv, cv, signedTx;

                      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                        while (1) {
                          switch (_context17.prev = _context17.next) {
                            case 0:
                              if (!(!Array.isArray(accounts) || !accounts.length)) {
                                _context17.next = 2;
                                break;
                              }

                              throw new Error('No account selected. Must call eth_requestAccounts first.');

                            case 2:
                              if (transactionObject.hasOwnProperty('from')) {
                                signingAccount = accounts.find(function (account) {
                                  return account.address === transactionObject.from;
                                });
                              }

                              signingAccount = signingAccount ? signingAccount : accounts[0];
                              _signingAccount = signingAccount, derivationPath = _signingAccount.derivationPath, address = _signingAccount.address;
                              transactionObject.gasLimit = transactionObject.gas || transactionObject.gasLimit; // 'gas' is an invalid property for the TransactionRequest type

                              delete transactionObject.gas;
                              signer = ethersProvider.getSigner(address);
                              _context17.next = 10;
                              return signer.populateTransaction(transactionObject);

                            case 10:
                              populatedTransaction = _context17.sent;

                              if (populatedTransaction.hasOwnProperty('nonce') && typeof populatedTransaction.nonce === 'number') {
                                populatedTransaction.nonce = populatedTransaction.nonce.toString(16);
                              }

                              updateBigNumberFields = bigNumberFieldsToStrings(populatedTransaction); // Set the `from` field to the currently selected account

                              transactionData = createTrezorTransactionObject(updateBigNumberFields);
                              chainId = currentChain.hasOwnProperty('id') ? Number.parseInt(currentChain.id) : 1;
                              _context17.next = 17;
                              return getCommon({
                                customNetwork: customNetwork,
                                chainId: chainId
                              });

                            case 17:
                              common = _context17.sent;
                              _context17.next = 20;
                              return trezorSignTransaction(derivationPath, transactionData);

                            case 20:
                              trezorResult = _context17.sent;

                              if (trezorResult.success) {
                                _context17.next = 24;
                                break;
                              }

                              message = trezorResult.payload.error === 'Unknown message' ? 'This type of transactions is not supported on this device' : trezorResult.payload.error;
                              throw new Error(message);

                            case 24:
                              _trezorResult$payload = trezorResult.payload, r = _trezorResult$payload.r, s = _trezorResult$payload.s;
                              v = trezorResult.payload.v; // EIP155 support. check/recalc signature v value.

                              rv = parseInt(v, 16);
                              cv = parseInt(currentChain.id) * 2 + 35;

                              if (rv !== cv && (rv & cv) !== rv) {
                                cv += 1; // add signature v bit.
                              }

                              v = cv.toString(16);
                              signedTx = Transaction.fromTxData(_objectSpread(_objectSpread({}, populatedTransaction), {}, {
                                v: "0x".concat(v),
                                r: r,
                                s: s
                              }), {
                                common: common
                              });
                              return _context17.abrupt("return", signedTx ? "0x".concat(signedTx.serialize().toString('hex')) : '');

                            case 32:
                            case "end":
                              return _context17.stop();
                          }
                        }
                      }, _callee17);
                    }));
                    return _signTransaction.apply(this, arguments);
                  };

                  signTransaction = function _signTransaction2(_x12) {
                    return _signTransaction.apply(this, arguments);
                  };

                  trezorSignTransaction = function _trezorSignTransactio(path, transactionData) {
                    try {
                      return TrezorConnect.ethereumSignTransaction({
                        path: path,
                        transaction: transactionData
                      });
                    } catch (error) {
                      throw new Error("There was an error signing transaction - Error: ".concat(error));
                    }
                  };

                  createTrezorTransactionObject = function _createTrezorTransact(transactionData) {
                    if (!transactionData || !transactionData.hasOwnProperty('gasLimit') && !transactionData.hasOwnProperty('gas')) {
                      throw new Error('There was no Transaction Object or both the gasLimit and gas property are missing');
                    }

                    var gasLimit = transactionData.gasLimit || transactionData.gas;

                    if (transactionData.maxFeePerGas || transactionData.maxPriorityFeePerGas) {
                      return {
                        to: transactionData.to,
                        value: transactionData.value,
                        gasLimit: gasLimit,
                        maxFeePerGas: transactionData.maxFeePerGas,
                        maxPriorityFeePerGas: transactionData.maxPriorityFeePerGas,
                        nonce: transactionData.nonce,
                        chainId: parseInt(currentChain.id),
                        data: transactionData.hasOwnProperty('data') ? transactionData.data : ''
                      };
                    }

                    return {
                      to: transactionData.to,
                      value: transactionData.value,
                      gasPrice: transactionData.gasPrice,
                      gasLimit: gasLimit,
                      nonce: transactionData.nonce,
                      chainId: parseInt(currentChain.id),
                      data: transactionData.hasOwnProperty('data') ? transactionData.data : ''
                    };
                  };

                  _getPublicKey = function _getPublicKey3() {
                    _getPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(dPath) {
                      var result;
                      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                        while (1) {
                          switch (_context16.prev = _context16.next) {
                            case 0:
                              if (dPath) {
                                _context16.next = 2;
                                break;
                              }

                              throw new Error('a derivation path is needed to get the public key');

                            case 2:
                              _context16.prev = 2;
                              _context16.next = 5;
                              return TrezorConnect.getPublicKey({
                                path: dPath,
                                coin: 'ETH'
                              });

                            case 5:
                              result = _context16.sent;

                              if (result.success) {
                                _context16.next = 8;
                                break;
                              }

                              throw new Error(result.payload.error);

                            case 8:
                              account = {
                                publicKey: result.payload.publicKey,
                                chainCode: result.payload.chainCode,
                                path: result.payload.serializedPath
                              };
                              return _context16.abrupt("return", account);

                            case 12:
                              _context16.prev = 12;
                              _context16.t0 = _context16["catch"](2);
                              throw new Error("There was an error accessing your Trezor accounts - Error: ".concat(_context16.t0));

                            case 15:
                            case "end":
                              return _context16.stop();
                          }
                        }
                      }, _callee16, null, [[2, 12]]);
                    }));
                    return _getPublicKey.apply(this, arguments);
                  };

                  getPublicKey = function _getPublicKey2(_x11) {
                    return _getPublicKey.apply(this, arguments);
                  };

                  _getAddress = function _getAddress3() {
                    _getAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(path) {
                      var errorMsg, result;
                      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                        while (1) {
                          switch (_context15.prev = _context15.next) {
                            case 0:
                              errorMsg = "Unable to derive address from path ".concat(path);
                              _context15.prev = 1;
                              _context15.next = 4;
                              return TrezorConnect.ethereumGetAddress({
                                path: path,
                                showOnTrezor: true
                              });

                            case 4:
                              result = _context15.sent;

                              if (result.success) {
                                _context15.next = 7;
                                break;
                              }

                              throw new Error(errorMsg);

                            case 7:
                              return _context15.abrupt("return", result.payload.address);

                            case 10:
                              _context15.prev = 10;
                              _context15.t0 = _context15["catch"](1);
                              console.error(_context15.t0);
                              throw new Error(errorMsg);

                            case 14:
                            case "end":
                              return _context15.stop();
                          }
                        }
                      }, _callee15, null, [[1, 10]]);
                    }));
                    return _getAddress.apply(this, arguments);
                  };

                  getAddress = function _getAddress2(_x10) {
                    return _getAddress.apply(this, arguments);
                  };

                  EventEmitter = _ref6.EventEmitter, chains = _ref6.chains;
                  _context19.next = 13;
                  return import('trezor-connect');

                case 13:
                  _yield$import2 = _context19.sent;
                  Trezor = _yield$import2.default;
                  _context19.next = 17;
                  return import('@ethereumjs/tx');

                case 17:
                  _yield$import3 = _context19.sent;
                  Transaction = _yield$import3.Transaction;
                  _context19.next = 21;
                  return import('@web3-onboard/common');

                case 21:
                  _yield$import4 = _context19.sent;
                  accountSelect = _yield$import4.accountSelect;
                  bigNumberFieldsToStrings = _yield$import4.bigNumberFieldsToStrings;
                  createEIP1193Provider = _yield$import4.createEIP1193Provider;
                  ProviderRpcError = _yield$import4.ProviderRpcError;
                  getCommon = _yield$import4.getCommon;
                  getHardwareWalletProvider = _yield$import4.getHardwareWalletProvider;
                  _context19.next = 30;
                  return import('ethereumjs-util');

                case 30:
                  ethUtil = _context19.sent;
                  _context19.next = 33;
                  return import('eth-crypto');

                case 33:
                  compress = _context19.sent.publicKey.compress;
                  _context19.next = 36;
                  return import('@ethersproject/providers');

                case 36:
                  _yield$import5 = _context19.sent;
                  StaticJsonRpcProvider = _yield$import5.StaticJsonRpcProvider;

                  if (!(!options || !options.email || !options.appUrl)) {
                    _context19.next = 40;
                    break;
                  }

                  throw new Error('Email and AppUrl required in Trezor options for Trezor Wallet Connection');

                case 40:
                  email = options.email, appUrl = options.appUrl, customNetwork = options.customNetwork; // @ts-ignore

                  TrezorConnect = Trezor.default || Trezor;
                  TrezorConnect.manifest({
                    email: email,
                    appUrl: appUrl
                  });
                  eventEmitter = new EventEmitter();
                  currentChain = chains[0];

                  scanAccounts = /*#__PURE__*/function () {
                    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref7) {
                      var derivationPath, chainId, asset, _yield$getPublicKey, publicKey, chainCode, path, address;

                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              derivationPath = _ref7.derivationPath, chainId = _ref7.chainId, asset = _ref7.asset;
                              currentChain = chains.find(function (_ref9) {
                                var id = _ref9.id;
                                return id === chainId;
                              }) || currentChain;
                              ethersProvider = new StaticJsonRpcProvider(currentChain.rpcUrl);
                              _context4.next = 5;
                              return getPublicKey(derivationPath);

                            case 5:
                              _yield$getPublicKey = _context4.sent;
                              publicKey = _yield$getPublicKey.publicKey;
                              chainCode = _yield$getPublicKey.chainCode;
                              path = _yield$getPublicKey.path;

                              if (!(derivationPath !== TREZOR_DEFAULT_PATH)) {
                                _context4.next = 22;
                                break;
                              }

                              _context4.next = 12;
                              return getAddress(path);

                            case 12:
                              address = _context4.sent;
                              _context4.t0 = derivationPath;
                              _context4.t1 = address;
                              _context4.t2 = asset.label;
                              _context4.next = 18;
                              return ethersProvider.getBalance(address.toLowerCase());

                            case 18:
                              _context4.t3 = _context4.sent;
                              _context4.t4 = {
                                asset: _context4.t2,
                                value: _context4.t3
                              };
                              _context4.t5 = {
                                derivationPath: _context4.t0,
                                address: _context4.t1,
                                balance: _context4.t4
                              };
                              return _context4.abrupt("return", [_context4.t5]);

                            case 22:
                              return _context4.abrupt("return", getAddresses({
                                publicKey: compress(publicKey),
                                chainCode: chainCode || '',
                                path: derivationPath
                              }, asset, ethersProvider));

                            case 23:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    return function scanAccounts(_x9) {
                      return _ref8.apply(this, arguments);
                    };
                  }();

                  getAccountFromAccountSelect = /*#__PURE__*/function () {
                    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              _context5.next = 2;
                              return accountSelect({
                                basePaths: DEFAULT_BASE_PATHS,
                                assets: assets,
                                chains: chains,
                                scanAccounts: scanAccounts
                              });

                            case 2:
                              accounts = _context5.sent;

                              if (Array.isArray(accounts) && accounts.length && accounts[0].hasOwnProperty('address')) {
                                eventEmitter.emit('accountsChanged', [accounts[0].address]);
                              }

                              return _context5.abrupt("return", accounts);

                            case 5:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function getAccountFromAccountSelect() {
                      return _ref10.apply(this, arguments);
                    };
                  }();

                  trezorProvider = getHardwareWalletProvider(function () {
                    return currentChain === null || currentChain === void 0 ? void 0 : currentChain.rpcUrl;
                  });
                  provider = createEIP1193Provider(trezorProvider, {
                    eth_requestAccounts: function () {
                      var _eth_requestAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                        var accounts;
                        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                _context6.next = 2;
                                return getAccountFromAccountSelect();

                              case 2:
                                accounts = _context6.sent;

                                if (Array.isArray(accounts)) {
                                  _context6.next = 5;
                                  break;
                                }

                                throw new Error('No account selected. Must call eth_requestAccounts first.');

                              case 5:
                                if (!(accounts.length === 0)) {
                                  _context6.next = 7;
                                  break;
                                }

                                throw new ProviderRpcError({
                                  code: 4001,
                                  message: 'User rejected the request.'
                                });

                              case 7:
                                if (accounts[0].hasOwnProperty('address')) {
                                  _context6.next = 9;
                                  break;
                                }

                                throw new Error('No address property associated with the selected account');

                              case 9:
                                return _context6.abrupt("return", [accounts[0].address]);

                              case 10:
                              case "end":
                                return _context6.stop();
                            }
                          }
                        }, _callee6);
                      }));

                      function eth_requestAccounts() {
                        return _eth_requestAccounts.apply(this, arguments);
                      }

                      return eth_requestAccounts;
                    }(),
                    eth_selectAccounts: function () {
                      var _eth_selectAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                        var accounts;
                        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                          while (1) {
                            switch (_context7.prev = _context7.next) {
                              case 0:
                                _context7.next = 2;
                                return getAccountFromAccountSelect();

                              case 2:
                                accounts = _context7.sent;
                                return _context7.abrupt("return", accounts.map(function (_ref11) {
                                  var address = _ref11.address;
                                  return address;
                                }));

                              case 4:
                              case "end":
                                return _context7.stop();
                            }
                          }
                        }, _callee7);
                      }));

                      function eth_selectAccounts() {
                        return _eth_selectAccounts.apply(this, arguments);
                      }

                      return eth_selectAccounts;
                    }(),
                    eth_accounts: function () {
                      var _eth_accounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                          while (1) {
                            switch (_context8.prev = _context8.next) {
                              case 0:
                                return _context8.abrupt("return", Array.isArray(accounts) && accounts.length && accounts[0].hasOwnProperty('address') ? [accounts[0].address] : []);

                              case 1:
                              case "end":
                                return _context8.stop();
                            }
                          }
                        }, _callee8);
                      }));

                      function eth_accounts() {
                        return _eth_accounts.apply(this, arguments);
                      }

                      return eth_accounts;
                    }(),
                    eth_chainId: function () {
                      var _eth_chainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                          while (1) {
                            switch (_context9.prev = _context9.next) {
                              case 0:
                                return _context9.abrupt("return", currentChain.hasOwnProperty('id') ? currentChain.id : '');

                              case 1:
                              case "end":
                                return _context9.stop();
                            }
                          }
                        }, _callee9);
                      }));

                      function eth_chainId() {
                        return _eth_chainId.apply(this, arguments);
                      }

                      return eth_chainId;
                    }(),
                    eth_signTransaction: function () {
                      var _eth_signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref12) {
                        var _ref12$params, transactionObject;

                        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                          while (1) {
                            switch (_context10.prev = _context10.next) {
                              case 0:
                                _ref12$params = _slicedToArray(_ref12.params, 1), transactionObject = _ref12$params[0];
                                return _context10.abrupt("return", signTransaction(transactionObject));

                              case 2:
                              case "end":
                                return _context10.stop();
                            }
                          }
                        }, _callee10);
                      }));

                      function eth_signTransaction(_x15) {
                        return _eth_signTransaction.apply(this, arguments);
                      }

                      return eth_signTransaction;
                    }(),
                    eth_sendTransaction: function () {
                      var _eth_sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref13) {
                        var baseRequest, params, signedTx, transactionHash;
                        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                          while (1) {
                            switch (_context11.prev = _context11.next) {
                              case 0:
                                baseRequest = _ref13.baseRequest, params = _ref13.params;
                                _context11.next = 3;
                                return provider.request({
                                  method: 'eth_signTransaction',
                                  params: params
                                });

                              case 3:
                                signedTx = _context11.sent;
                                _context11.next = 6;
                                return baseRequest({
                                  method: 'eth_sendRawTransaction',
                                  params: [signedTx]
                                });

                              case 6:
                                transactionHash = _context11.sent;
                                return _context11.abrupt("return", transactionHash);

                              case 8:
                              case "end":
                                return _context11.stop();
                            }
                          }
                        }, _callee11);
                      }));

                      function eth_sendTransaction(_x16) {
                        return _eth_sendTransaction.apply(this, arguments);
                      }

                      return eth_sendTransaction;
                    }(),
                    eth_sign: function () {
                      var _eth_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref14) {
                        var _ref14$params, address, message;

                        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                          while (1) {
                            switch (_context12.prev = _context12.next) {
                              case 0:
                                _ref14$params = _slicedToArray(_ref14.params, 2), address = _ref14$params[0], message = _ref14$params[1];
                                return _context12.abrupt("return", signMessage(address, {
                                  data: message
                                }));

                              case 2:
                              case "end":
                                return _context12.stop();
                            }
                          }
                        }, _callee12);
                      }));

                      function eth_sign(_x17) {
                        return _eth_sign.apply(this, arguments);
                      }

                      return eth_sign;
                    }(),
                    personal_sign: function () {
                      var _personal_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref15) {
                        var _ref15$params, message, address;

                        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                          while (1) {
                            switch (_context13.prev = _context13.next) {
                              case 0:
                                _ref15$params = _slicedToArray(_ref15.params, 2), message = _ref15$params[0], address = _ref15$params[1];
                                return _context13.abrupt("return", signMessage(address, {
                                  data: message
                                }));

                              case 2:
                              case "end":
                                return _context13.stop();
                            }
                          }
                        }, _callee13);
                      }));

                      function personal_sign(_x18) {
                        return _personal_sign.apply(this, arguments);
                      }

                      return personal_sign;
                    }(),
                    wallet_switchEthereumChain: function () {
                      var _wallet_switchEthereumChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref16) {
                        var _ref16$params, chainId;

                        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                          while (1) {
                            switch (_context14.prev = _context14.next) {
                              case 0:
                                _ref16$params = _slicedToArray(_ref16.params, 1), chainId = _ref16$params[0].chainId;
                                currentChain = chains.find(function (_ref17) {
                                  var id = _ref17.id;
                                  return id === chainId;
                                }) || currentChain;

                                if (currentChain) {
                                  _context14.next = 4;
                                  break;
                                }

                                throw new Error('chain must be set before switching');

                              case 4:
                                eventEmitter.emit('chainChanged', currentChain.id);
                                return _context14.abrupt("return", null);

                              case 6:
                              case "end":
                                return _context14.stop();
                            }
                          }
                        }, _callee14);
                      }));

                      function wallet_switchEthereumChain(_x19) {
                        return _wallet_switchEthereumChain.apply(this, arguments);
                      }

                      return wallet_switchEthereumChain;
                    }(),
                    eth_signTypedData: null,
                    wallet_addEthereumChain: null
                  });
                  provider.on = eventEmitter.on.bind(eventEmitter);
                  return _context19.abrupt("return", {
                    provider: provider
                  });

                case 51:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19);
        }));

        function getInterface(_x8) {
          return _getInterface.apply(this, arguments);
        }

        return getInterface;
      }()
    };
  };
}

export default trezor;